import { render, staticRenderFns } from "./select-ajax-field.vue?vue&type=template&id=38703e43&lang=pug"
import script from "./select-ajax-field.vue?vue&type=script&lang=js"
export * from "./select-ajax-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports